import { render, staticRenderFns } from "./additional-info-preloader.vue?vue&type=template&id=325dbd8e&scoped=true"
import script from "./additional-info-preloader.vue?vue&type=script&lang=ts"
export * from "./additional-info-preloader.vue?vue&type=script&lang=ts"
import style0 from "./additional-info-preloader.vue?vue&type=style&index=0&id=325dbd8e&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325dbd8e",
  null
  
)

export default component.exports